import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { fetchAllMyTasks } from "../services/tms";
import { roundNumber } from "../utils/roundNumber";
import TmsNavbar from "../components/TmsNavbar";
import { fetchUsers } from "services/data";
import { fetchWatomsRelatedVtcs } from "services/watoms/watomsData";
import TmsMyTasksCollapse from "components/ui/TmsMyTasksCollapse";

const WatomsMyTasks = () => {
    const { userInfo } = useAuth();
    const [isFilter, setIsFilter] = useState(false);
    const [allAssigneeTasks, setAllAssigneeTasks] = useState([]);
    const [allAssignerTasks, setAllAssignerTasks] = useState([]);
    const [allReviewerTasks, setAllReviewerTasks] = useState([]);
    const [allManagerTasks, setAllManagerTasks] = useState([]);
    const [unfilteredAllReviewerTasks, setUnfilteredAllReviewerTasks] = useState([]);
    const [unfilteredAllAssigneeTasks, setUnfilteredAllAssigneeTasks] = useState([]);
    const [unfilteredAllAssignerTasks, setUnfilteredAllAssignerTasks] = useState([]);
    const [unfilteredAllManagerTasks, setUnfilteredAllManagerTasks] = useState([]);
    const [selectedMonthDetails, setSelectedMonthDetails] = useState({
        finishedPercentage: 0,
        avgManagerSpeed: 0,
        avgManagerQuality: 0,
        avgReviewerSpeed: 0,
        avgReviewerQuality: 0,
    });
    const [vtcs, setVtcs] = useState([]);
    const [selectedVtc, setSelectedVtc] = useState("");
    const [employees, setEmployees] = useState([]);
    const [unFilteredEmployees, setUnFilteredEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(userInfo.id);
    const [selectedImportance2, setSelectedImportance2] = useState("");

    useEffect(() => {
        const loadVtcs = async () => {
            const response = await fetchWatomsRelatedVtcs();
            setVtcs(response)
        }

        const loadEmployees = async () => {
            const response = await fetchUsers(userInfo);
            setEmployees(response)
            setUnFilteredEmployees(response)
        }

        loadVtcs();
        loadEmployees();
    }, [])

    useEffect(() => {
        const filterData = () => {
            if (selectedVtc === "") {
                setEmployees(unFilteredEmployees)
            } else {
                setEmployees(unFilteredEmployees.filter(emp => Number(emp.employee.organization_id) === Number(selectedVtc)))
            }
        }

        filterData();
    }, [selectedVtc])

    useEffect(() => {
        const filterData = () => {
            const sortByCreatedAtDesc = (a, b) =>
                new Date(b.createdAt) - new Date(a.createdAt);
            if (selectedImportance2 === "") {
                calculateTmsDetails(unfilteredAllAssigneeTasks)
                setAllAssigneeTasks(unfilteredAllAssigneeTasks)
                setAllAssignerTasks(unfilteredAllAssignerTasks)
                setAllReviewerTasks(unfilteredAllReviewerTasks)
                setAllManagerTasks(unfilteredAllManagerTasks)
            } else {
                const allMyAssigneeTasks = unfilteredAllAssigneeTasks.filter(task => task.importance === selectedImportance2).slice().sort(sortByCreatedAtDesc);
                const allMyAssignerTasks = unfilteredAllAssignerTasks.filter(task => task.importance === selectedImportance2).slice().sort(sortByCreatedAtDesc);
                const allMyReviewerTasks = unfilteredAllReviewerTasks.filter(task => task.importance === selectedImportance2).slice().sort(sortByCreatedAtDesc);
                const allMyManagerTasks = unfilteredAllManagerTasks.filter(task => task.importance === selectedImportance2).slice().sort(sortByCreatedAtDesc);
                calculateTmsDetails(allMyAssigneeTasks)
                setAllAssigneeTasks(allMyAssigneeTasks)
                setAllAssignerTasks(allMyAssignerTasks)
                setAllReviewerTasks(allMyReviewerTasks)
                setAllManagerTasks(allMyManagerTasks)
            }
        }

        filterData();
    }, [selectedImportance2])

    const calculateTmsDetails = (data) => {
        const finishedTasksPercentage = data ? data?.filter(task => task.status === "finished" || task.status === "submitted").length : 0;
        const totalTasks = data ? data?.length : 0;
        const avgManagerSpeed = data?.length
            ? roundNumber(
                data.reduce(
                    (sum, task) => sum + (Number(task.manager_speed_percentage) || 0),
                    0
                ) / data.length
            )
            : 0;
        const avgManagerQuality = data?.length
            ? roundNumber(
                data.reduce(
                    (sum, task) => sum + (Number(task.manager_quality_percentage) || 0),
                    0
                ) / data.length
            )
            : 0;
        const avgReviewerSpeed = data?.length
            ? roundNumber(
                data.reduce(
                    (sum, task) => sum + (Number(task.reviewer_speed_percentage) || 0),
                    0
                ) / data.length
            )
            : 0;
        const avgReviewerQuality = data?.length
            ? roundNumber(
                data.reduce(
                    (sum, task) => sum + (Number(task.reviewer_quality_percentage) || 0),
                    0
                ) / data.length
            )
            : 0;

        setSelectedMonthDetails(prev => ({
            ...prev,
            finishedPercentage: finishedTasksPercentage ? roundNumber((Number(finishedTasksPercentage) / Number(totalTasks)) * 100) : 0,
            avgManagerSpeed, avgManagerQuality, avgReviewerSpeed, avgReviewerQuality,
        }));
    }

    useEffect(() => {
        const loadMyTasks = async () => {
            const response = await fetchAllMyTasks(selectedEmployee, "ebdaedu");
            const sortByCreatedAtDesc = (a, b) =>
                new Date(b.createdAt) - new Date(a.createdAt);
            const allMyAssigneeTasks = response.myAssigneeTasks.flatMap(month => month.tasks).slice().sort(sortByCreatedAtDesc);
            const allMyAssignerTasks = response.myAssignerTasks.flatMap(month => month.tasks).slice().sort(sortByCreatedAtDesc);
            const allMyReviewerTasks = response.myReviewerTasks.flatMap(month => month.tasks).slice().sort(sortByCreatedAtDesc);
            const allMyManagerTasks = response.myManagerTasks.flatMap(month => month.tasks).slice().sort(sortByCreatedAtDesc);
            calculateTmsDetails(allMyAssigneeTasks)
            setAllAssigneeTasks(allMyAssigneeTasks)
            setAllAssignerTasks(allMyAssignerTasks)
            setAllReviewerTasks(allMyReviewerTasks)
            setAllManagerTasks(allMyManagerTasks)
            setUnfilteredAllAssigneeTasks(allMyAssigneeTasks)
            setUnfilteredAllAssignerTasks(allMyAssignerTasks)
            setUnfilteredAllReviewerTasks(allMyReviewerTasks)
            setUnfilteredAllManagerTasks(allMyManagerTasks)
        }

        loadMyTasks();
    }, [selectedEmployee])
    return (
        <>
            <TmsNavbar
                newTaskStatus={true}
                shareStatus={false}
                isFilter={isFilter}
                setIsFilter={setIsFilter}
                filterTmsStatus={true}
                addTaskPage={true}
                searchStatus={false}
                darkmodeStatus={false}
            />
            <div className="flex flex-col gap-8 items-center min-h-[88vh] h-fit bg-[#0a183d] pt-1 text-white">
                <h1 className="text-2xl font-bold text-center text-yellow-500">عرض و تصنيف المهام</h1>
                {(userInfo?.code === 1 || userInfo?.code === 3 || userInfo?.code === 2) && <div className="w-fit flex md:flex-row flex-col gap-2 px-2">
                    <div className="w-44 flex flex-col items-center">
                        <label className="text-sm font-semibold text-gray-200 mb-1">
                            الاولوية
                        </label>
                        <select value={selectedImportance2} onChange={(e) => setSelectedImportance2(e.target.value)} className="w-full text-center px-2 py-1 rounded-md bg-[#181f2e] text-white border border-gray-600 focus:border-[#0af] focus:outline-none cursor-pointer">
                            <option value="">الرجاء اختيار الاولوية</option>
                            <option value="urgent">قصوي</option>
                            <option value="important">متوسطة</option>
                            <option value="normal">عادية</option>
                        </select>
                    </div>

                    <div className="w-44 flex flex-col items-center">
                        <label className="text-sm font-semibold text-gray-200 mb-1">
                            المنفذيين
                        </label>
                        <select value={selectedEmployee} onChange={(e) => setSelectedEmployee(e.target.value)} className="w-full text-center px-2 py-1 rounded-md bg-[#181f2e] text-white border border-gray-600 focus:border-[#0af] focus:outline-none cursor-pointer">
                            <option value="">الرجاء اختيار المنفذ</option>
                            {employees.map(emp => (
                                <option value={emp.id}>{emp.employee.employee_first_name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="w-44 flex flex-col items-center">
                        <label className="text-sm font-semibold text-gray-200 mb-1">
                            الجهة الفرعية
                        </label>
                        <select value={selectedVtc} onChange={(e) => setSelectedVtc(e.target.value)} className="w-full text-center px-2 py-1 rounded-md bg-[#181f2e] text-white border border-gray-600 focus:border-[#0af] focus:outline-none cursor-pointer">
                            <option value="">الرجاء اختيار الجهة</option>
                            {vtcs.map(vtc => (
                                <option id={vtc.id} value={vtc.id}>{vtc.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* <div className="w-44 flex flex-col items-center">
                        <label className="text-sm font-semibold text-gray-200 mb-1">
                            الجهة الرئيسية
                        </label>
                        <select className="w-full text-center px-2 py-1 rounded-md bg-[#181f2e] text-white border border-gray-600 focus:border-[#0af] focus:outline-none cursor-pointer">
                            <option value="">الرجاء اختيار الجهة</option>
                            <option value="">الاختيار الاول</option>
                            <option value="">الاختيار الثاني</option>
                            <option value="">الاختيار الثالث</option>
                        </select>
                    </div> */}
                </div>}
                <div className="flex w-[95%] justify-between items-center">
                    <div className="flex flex-col">
                        <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>اجمالي تقييم المهام</div>
                        <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2 ${roundNumber((((selectedMonthDetails.avgManagerSpeed + selectedMonthDetails.avgReviewerSpeed) / 2) * 0.3) + (((selectedMonthDetails.avgManagerQuality + selectedMonthDetails.avgReviewerQuality) / 2) * 0.3) + (selectedMonthDetails.finishedPercentage * 0.4)) < 50 && "text-red-500 font-bold"}`}>{roundNumber((((selectedMonthDetails.avgManagerSpeed + selectedMonthDetails.avgReviewerSpeed) / 2) * 0.3) + (((selectedMonthDetails.avgManagerQuality + selectedMonthDetails.avgReviewerQuality) / 2) * 0.3) + (selectedMonthDetails.finishedPercentage * 0.4))}%</div>
                    </div>
                    <div className="w-0 border-white border-l-2 h-12" />
                    <div className="flex gap-2">
                        <div className="flex flex-col">
                            <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>اولوية عادية</div>
                            <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.filter(task => task.importance === "normal").length}</div>
                        </div>
                        <div className="flex flex-col">
                            <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>اولوية متوسطة</div>
                            <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.filter(task => task.importance === "important").length}</div>
                        </div>
                        <div className="flex flex-col">
                            <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>اولوية قصوي</div>
                            <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.filter(task => task.importance === "urgent").length}</div>
                        </div>
                    </div>
                    <div className="w-0 border-white border-l-2 h-12" />
                    <div className="flex gap-2">
                        <div className="flex flex-col">
                            <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>مهمة صغيرة</div>
                            <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.filter(task => task.size === "small").length}</div>
                        </div>
                        <div className="flex flex-col">
                            <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>مهمة متوسطة</div>
                            <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.filter(task => task.size === "medium").length}</div>
                        </div>
                        <div className="flex flex-col">
                            <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>مهمة كبيرة</div>
                            <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.filter(task => task.size === "large").length}</div>
                        </div>
                    </div>
                    <div className="w-0 border-white border-l-2 h-12" />
                    <div className="flex flex-col">
                        <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>اجمالي عدد المهام</div>
                        <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.length}</div>
                    </div>
                </div>
                <div className="h-0 border-t-2 border-white w-[60%]" />
                {/* My Tasks */}
                <TmsMyTasksCollapse
                    title="مهامي كمنفذ"
                    tasks={allAssigneeTasks}
                    bgColor="bg-[#5268b1]"
                    hoverColor="hover:bg-[#46599b]"
                    system="watoms"
                />
                {/* Assigned Tasks */}
                <TmsMyTasksCollapse
                    title="مهام عينتها لغيري"
                    tasks={allAssignerTasks}
                    bgColor="bg-[#3d56aa]"
                    hoverColor="hover:bg-[#334994]"
                    system="watoms"
                />
                {/* Reviewer Tasks */}
                <TmsMyTasksCollapse
                    title="مهامي كمراجع"
                    tasks={allReviewerTasks}
                    bgColor="bg-[#476adc]"
                    hoverColor="hover:bg-[#3958c5]"
                    system="watoms"
                />
                {/* Manager Tasks */}
                <TmsMyTasksCollapse
                    title="مهامي كمدير"
                    tasks={allManagerTasks}
                    bgColor="bg-[#1c2952]"
                    hoverColor="hover:bg-[#5268b1]"
                    system="watoms"
                />
            </div>
        </>
    )
}

export default WatomsMyTasks;